import React, { useRef, useState, useCallback } from "react";
import * as Scrivito from "scrivito";
import { useQuery } from "urql";
import { Container } from "reactstrap";
import { ProjectDataQry } from "api/queries";
import { ObjValidator } from "components";
import { ProjectHeader } from "components/ProjectHeader/ProjectHeader";
import { useAppBaseContext } from "providers/AppBaseProvider";
import { useTranslate } from "hooks";
import { useProjectDataStore } from "stores/projectStore";
import { useNavigateToProject } from "hooks/projectHooks";
import { PROJECT_CONFIGURATOR_TAB_TYPES } from "variables";
import { ProjectItemProperties } from "./SubComponents/ProjectItemProperties";
import { ProjectItemUploads } from "./SubComponents/ProjectItemUploads";
import { ProjectSummary } from "./SubComponents/ProjectSummary";

import s from "./ProjectItem.module.scss";

const ProjectItem = Scrivito.connect(({ page }) => {
  const translate = useTranslate();
  const [activeTab, setActiveTab] = useState(
    PROJECT_CONFIGURATOR_TAB_TYPES.PRODUCT_LIST,
  );
  const navigateToProject = useNavigateToProject();
  const projectId = useProjectDataStore((state) => state.projectId);
  const { lang: language } = useAppBaseContext();

  const [{ data, fetching }, reexecuteQuery] = useQuery({
    query: ProjectDataQry,
    variables: { input: { id: projectId, languageCode: language } },
    pause: !projectId,
  });
  const productListRef = useRef({});
  const { project = {} } = data ?? {};

  const handleChangeActiveTab = useCallback((e) => {
    setActiveTab(e.target.id);
  }, []);

  return (
    <>
      <div className="bg-gray-100">
        <Container className="py-5_5">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex justify-content-between align-items-center gap-4 mb-1">
              <ProjectHeader
                projectId={projectId}
                title={translate("PROJECT_DETAILS")}
                project={project}
                page={page}
                productListRef={productListRef}
              />
            </div>
            <div className="d-flex align-items-center gap-2"></div>
          </div>
          <h4 className={s.textWrap}>{project.title}</h4>
        </Container>
      </div>
      <ProjectItemProperties
        project={project}
        reexecuteQuery={reexecuteQuery}
        fetching={fetching}
      />
      <ProjectSummary
        project={project}
        onRedirectToConfiguratorClick={() =>
          navigateToProject.configurator(projectId)
        }
        productListRef={productListRef}
        activeTab={activeTab}
        handleChangeActiveTab={handleChangeActiveTab}
      />
      <ProjectItemUploads />
    </>
  );
});

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <ProjectItem {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("ProjectItem", CheckedPage);
